export const DASHBOARD = 'manage_outreaches';
export const OUTREACH = 'manage_outreaches';
